import { useFormStore } from '@/stores/form'
import axiosInstance from '@/services'

export default async function () {
  const formStore = useFormStore()

  const depositInfo = await axiosInstance.get('/api/establishment/getPayDepositInfo')
  Object.assign(formStore.extraMap, depositInfo)
}
